/**
 * «Ver alternativas» — los números de sections/pp-product-alternativas.liquid
 * (R-5, 19-oct-2026). El Liquid pinta las tarjetas SIN número; aquí se pone
 * el «desde N piezas» sólo cuando hay un dato real. Los números que no existen
 * NO se muestran: sin dato, el título se queda como lo dejó el Liquid.
 *
 * N — «Con tu logo, desde N piezas»: la entrada de la ley del precio
 *   (`print_studio.escalera_personalizacion`, el renglón de menos paquetes),
 *   pedida y escogida por PPPrecioPersonalizacion (pedir/elegir), el mismo
 *   código y la misma caché que la línea de precio de la ficha. Nunca un 25
 *   fijo: el sobre de burbuja empieza en 250, la bolsa en 100.
 *
 * M — «A tu medida, desde M piezas»: SÓLO cajas 0201, de la edge
 *   `cajas-minimo` (monorepo), el único dueño del mínimo por medida que la
 *   tienda puede preguntar: lee el piso de `a_la_medida.minimos_de_fabricacion`
 *   y los rangos del estilo, y convierte con `minimoPiezas` de box-geometry.
 *   Se le pregunta por las MISMAS medidas que lleva la liga (se leen del href),
 *   así que el número es el de la caja que abre el cotizador. Sólo cuenta si
 *   contesta `motivo: 'ok'`, `fabricable: true` y su `estilo_codigo` es el de
 *   la liga. Fuera de rango (la 13×13×13: el 0201 arranca en 15 cm de largo),
 *   piso no leído, otro estilo (0427, pizza…), bolsas (0 capacidades
 *   publicadas): sin número.
 *
 * La lógica pura va en window.PPVerAlternativas para que
 * tests/ver-alternativas.test.mjs la corra con red falsa.
 */
(function (root) {
  'use strict';

  if (root.PPVerAlternativas) return;

  var ESPERA_MS = 6000;
  /** El único estilo que contesta `cajas-minimo` (ESTILO_DEL_MINIMO). */
  var ESTILO_CON_MINIMO = '0201';

  function entero(v) {
    if (v === null || v === undefined || v === '' || typeof v === 'boolean') return null;
    var x = Number(v);
    return isFinite(x) && x > 0 && Math.floor(x) === x ? x : null;
  }

  function miles(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /** El título con número, o null si no hay plantilla o número. */
  function conNumero(plantilla, n) {
    var x = entero(n);
    if (x === null || typeof plantilla !== 'string' || plantilla.indexOf('{n}') === -1) return null;
    return plantilla.replace('{n}', miles(x));
  }

  /** N: las piezas de la entrada de la escalera, o null. */
  function piezasConLogo(filas, P) {
    if (!P || typeof P.elegir !== 'function') return null;
    var e = P.elegir(filas);
    return e && e.entrada ? entero(e.entrada.piezas) : null;
  }

  /**
   * Las medidas y el estilo que lleva la liga al cotizador de cajas, o null
   * si no lleva las tres medidas o no es de ESTILO_CON_MINIMO.
   */
  function medidasDeLiga(href) {
    var q = String(href || '');
    var i = q.indexOf('?');
    if (i === -1) return null;
    var params;
    try { params = new URLSearchParams(q.slice(i + 1)); } catch (e) { return null; }
    var estilo = params.get('estilo');
    if (estilo !== ESTILO_CON_MINIMO) return null;
    var out = { estilo: estilo };
    var ejes = ['largo', 'ancho', 'alto'];
    for (var k = 0; k < ejes.length; k++) {
      var v = params.get(ejes[k]);
      if (!v || !/^\d{1,6}(?:\.\d+)?$/.test(v) || !(Number(v) > 0)) return null;
      out[ejes[k]] = v;
    }
    return out;
  }

  /** M: el mínimo que contestó `cajas-minimo`, o null si no es un sí claro para ESE estilo. */
  function minimoDeRespuesta(resp, estilo) {
    if (!resp || typeof resp !== 'object') return null;
    if (resp.estilo_codigo !== estilo) return null;
    if (resp.motivo !== 'ok' || resp.fabricable !== true) return null;
    return typeof resp.minimo_piezas === 'number' ? entero(resp.minimo_piezas) : null;
  }

  /** GET a cajas-minimo. Promesa del cuerpo o null. Nunca rechaza. SÓLO `apikey` (CORS). */
  function pedirMinimo(cfg) {
    var base = String(cfg.url || '').replace(/\/+$/, '');
    var m = cfg.medidas;
    if (!m || !/^https:\/\//.test(base) || !cfg.key || typeof cfg.fetch !== 'function') return Promise.resolve(null);
    var control = typeof AbortController === 'function' ? new AbortController() : null;
    var reloj = control ? setTimeout(function () { control.abort(); }, cfg.espera || ESPERA_MS) : null;
    var url = base + '/functions/v1/cajas-minimo?largo=' + m.largo + '&ancho=' + m.ancho + '&alto=' + m.alto;
    return Promise.resolve()
      .then(function () {
        return cfg.fetch(url, { headers: { apikey: cfg.key }, signal: control ? control.signal : undefined });
      })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (x) { if (reloj) clearTimeout(reloj); return x; });
  }

  function poner(el, n) {
    if (!el) return;
    var texto = conNumero(el.getAttribute('data-plantilla'), n);
    el.setAttribute('data-pp-alt-estado', texto ? 'listo' : 'sin-numero');
    if (texto) el.textContent = texto;
  }

  function iniciar(doc, deps) {
    deps = deps || {};
    var secciones = doc.querySelectorAll('[data-pp-ver-alternativas]');
    var trabajos = [];
    for (var i = 0; i < secciones.length; i++) {
      (function (sec) {
        var url = sec.getAttribute('data-supabase-url');
        var key = sec.getAttribute('data-supabase-key');
        var logo = sec.querySelector('[data-pp-alt-numero="logo"]');
        var P = deps.precio || root.PPPrecioPersonalizacion;
        if (logo) {
          trabajos.push(
            (P && typeof P.pedir === 'function'
              ? P.pedir({ producto: sec.getAttribute('data-producto'), url: url, key: key, fetch: deps.fetch, almacen: deps.almacen, espera: deps.espera })
              : Promise.resolve(null)
            ).then(function (filas) { poner(logo, piezasConLogo(filas, P)); })
          );
        }
        var medida = sec.querySelector('[data-pp-alt-numero="medida"]');
        if (medida) {
          var ancla = medida.closest ? medida.closest('a') : null;
          var medidas = medidasDeLiga(ancla ? ancla.getAttribute('href') : '');
          if (!medidas) {
            poner(medida, null);
          } else {
            trabajos.push(
              pedirMinimo({ url: url, key: key, medidas: medidas, fetch: deps.fetch, espera: deps.espera })
                .then(function (resp) { poner(medida, minimoDeRespuesta(resp, medidas.estilo)); })
            );
          }
        }
      })(secciones[i]);
    }
    return Promise.all(trabajos);
  }

  root.PPVerAlternativas = {
    ESTILO_CON_MINIMO: ESTILO_CON_MINIMO,
    conNumero: conNumero,
    piezasConLogo: piezasConLogo,
    medidasDeLiga: medidasDeLiga,
    minimoDeRespuesta: minimoDeRespuesta,
    pedirMinimo: pedirMinimo,
    iniciar: iniciar
  };

  if (typeof document !== 'undefined' && typeof window !== 'undefined' && window.fetch) {
    var arrancar = function () {
      var almacen = null;
      try { almacen = window.sessionStorage; } catch (e) { almacen = null; }
      iniciar(document, { fetch: window.fetch.bind(window), almacen: almacen });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
    else arrancar();
  }
})(typeof window !== 'undefined' ? window : globalThis);
